// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Helmet } from 'react-helmet';
import { Box } from '@mui/material';
import Breadcrumb from 'src/layouts/full/shared/breadcrumb/Breadcrumb';
import { useSelector } from 'react-redux';
import { AppState, dispatch } from 'src/store/Store';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { publicRoutes } from 'src/routes/Router';

type Props = {
  description?: string;
  children: JSX.Element | JSX.Element[];
  title?: string;
  hideBreadcrump?: boolean;
  sx?: any;
};

const PageContainer = ({ title, description, hideBreadcrump = false, children, sx }: Props) => {
  const app_Rx = useSelector((state: AppState) => state.appGeneralReducer);
  const { authToken } = useSelector((state: AppState) => state.authReducer);
  const pathname = useLocation();

  const [isPublicPage, setIsPublicPage] = useState(true);
  // const navigate = useNavigate();
  // const scrollToTop = useRef<any>(null);

  // useEffect(() => {
  //   if (scrollToTop.current) {
  //     scrollToTop.current.scrollTo({ top: 0, behavior: 'auto' });
  //   }
  // }, [ ]);
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  useEffect(() => {
    if (authToken && !publicRoutes.map((page: any) => page.path).includes(pathname.pathname)) {
      setIsPublicPage(false);
    }
  }, [authToken, pathname.pathname, publicRoutes]);

  return (
    <Box sx={{ position: 'relative', minHeight: '100dvh', ...sx }}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Helmet>
      <Box sx={{ mt: isPublicPage ? 0 : '1rem', borderRadius: 0 }}>
      {/* <Box sx={{ borderRadius: 0 }}> */}
        {!hideBreadcrump && !isPublicPage && (
          <Box
            sx={{
              display: { xs: 'flex', md: 'none' },
              alignItems: 'center',
              my: '5px',
              width: '100%',
              minHeight: 'fit-content',
            }}
          >
            <Breadcrumb items={app_Rx?.breadcrumb} />
          </Box>
        )}
        {children}
      </Box>
    </Box>
  );
};

export default PageContainer;
